module.exports = __webpack_public_path__ + "img/3-4.20e6e697.svg";